// Sample data only — Leads executive mockup. Stages = current Leads board statuses.
// Conversion matches today's app: (converted + existing_customer) / (total − not_a_lead).
export const C = { teal: "#1F8A7C", fill: "#5CC4B4", soft: "#CFEAE5", neg: "#C2483A", warn: "#B7791F", grey: "#9AB0B8", ink: "#13212A" };

export const PERIODS = ["Week", "MTD", "Last 30 days", "QTD", "YTD"];

// Trend granularity follows the date picker: day for short ranges, week for QTD, month for YTD.
const wave = (n, base, amp, seed) => Array.from({ length: n }, (_, i) => Math.max(0, Math.round(base + amp * Math.sin((i + seed) * 1.3) + ((i * 7 + seed) % 3))));
export const trendFor = (p) => {
  const spec = { Week: [7, "d"], MTD: [23, "d"], "Last 30 days": [30, "d"], QTD: [13, "w"], YTD: [11, "m"] }[p];
  const [n, unit] = spec;
  const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov"];
  const scale = unit === "d" ? 1 : unit === "w" ? 6 : 24;
  const ins = wave(n, 3.5 * scale, 1.6 * scale, 1), wonArr = wave(n, 1.1 * scale, 0.6 * scale, 3);
  return ins.map((v, i) => ({
    m: unit === "d" ? `${p === "Last 30 days" ? "" : "Oct "}${i + 1}` : unit === "w" ? `Wk ${i + 1}` : MONTHS[i],
    in: v, actioned: Math.max(0, v - (i % 4 === 0 ? 1 : 0)), won: Math.min(wonArr[i], v), revenue: Math.min(wonArr[i], v) * 1240,
  }));
};
export const GRAIN = { Week: "by day", MTD: "by day", "Last 30 days": "by day", QTD: "by week", YTD: "by month" };

export const SERVICES = [["Boarding", 41, 14], ["Daycare", 29, 10], ["Grooming / Bath", 12, 4], ["Training", 8, 2], ["Evaluation only", 6, 1], ["Private Play", 4, 0]];

const FIRST = ["Mary", "Kelly", "Tom", "Priya", "James", "Lena", "Dan", "Sara", "Mike", "Ava", "Chris", "Nina"];
const LAST = ["Lee", "Ross", "Becker", "Shah", "Ortiz", "Park", "Rossi", "Kim", "Hale", "Diaz", "Wu", "Grant"];
const SRC = ["Website form", "Gmail", "Phone", "Instagram", "Walk-in"];
const SVC = ["Boarding", "Daycare", "Grooming / Bath", "Training"];
const REP = ["Ashley R.", "Marcus T.", "Jenna P.", "Front desk"];
export const leadsFor = (stage, n) => Array.from({ length: Math.min(n, 12) }, (_, i) => ({
  id: `L-${(stage.length * 997 + i * 131).toString(16)}`,
  name: `${FIRST[(i + stage.length) % 12]} ${LAST[(i * 5 + stage.length) % 12]}`,
  source: SRC[i % 5], service: stage.startsWith("Service: ") ? stage.slice(9) : SVC[(i + stage.length) % 4], rep: REP[i % 4],
  age: `${(i * 3 + stage.length) % 21 + 1}d`, stage,
}));

export const FUNNEL = { in: 100, notLead: 6, contacted: 92, qualified: 48, converted: 27, existing: 4, lost: 22, noResponse: 18 };
export const actionable = FUNNEL.in - FUNNEL.notLead;
export const won = FUNNEL.converted + FUNNEL.existing;
export const open = actionable - won - FUNNEL.lost - FUNNEL.noResponse;

export const KPIS = {
  conversion: (won / actionable) * 100, prevConversion: 29.8,
  dealSize: 1240, prevDealSize: 1105,
  pipeline: open * 1240 * (won / actionable),
  revenueWon: won * 1240,
  speedToLead: 38, prevSpeedToLead: 52, // minutes, median first response
  turnaround: 6.4, // hours between follow-ups, median
  avgAge: 9.2, // days, open leads
  touchesToWin: 3.1,
};

export const TREND = ["Jun", "Jul", "Aug", "Sep", "Oct", "Nov"].map((m, i) => ({
  m,
  in: [72, 88, 95, 81, 100, 64][i],
  actioned: [68, 85, 92, 79, 98, 61][i],
  won: [19, 24, 27, 22, 31, 18][i],
  revenue: [21800, 28400, 33100, 26300, 38400, 21900][i],
}));

export const REPS = [
  { name: "Ashley R.", leads: 34, actions: 121, first: 22, turn: 4.8, won: 13, rev: 16900 },
  { name: "Marcus T.", leads: 29, actions: 88, first: 41, turn: 7.1, won: 9, rev: 11200 },
  { name: "Jenna P.", leads: 21, actions: 70, first: 35, turn: 5.9, won: 7, rev: 8100 },
  { name: "Front desk", leads: 10, actions: 19, first: 96, turn: 12.5, won: 2, rev: 2200 },
];

export const LOST_REASONS = [["Price", 8], ["Booked elsewhere", 6], ["No vaccines / not eligible", 4], ["Timing / dates full", 3], ["Other", 1]];
